const originalConsoleWarn = console.warn;
console.warn = (...args) => {
  if (
    typeof args[0] === "string" &&
    (args[0].includes(
      "Detected a large number of updates inside startTransition"
    ) ||
      args[0].includes(`misspelled option "enableLiveAutocompletion"`) ||
      args[0].includes(`predictableActionArguments`))
  ) {
    return;
  }
  originalConsoleWarn(...args);
};

export {};
